import {IBuyback} from '../models/Price';

export const SAVE_BUYBACK = 'SAVE_BUYBACK';
export const SAVE_BUYBACK_SUCCESS = 'SAVE_BUYBACK_SUCCESS';
export const SAVE_BUYBACK_ERROR = 'SAVE_BUYBACK_ERROR';

export const FETCH_BUYBACK = 'FETCH_BUYBACK';
export const FETCH_BUYBACK_SUCCESS = 'FETCH_BUYBACK_SUCCESS';
export const FETCH_BUYBACK_ERROR = 'FETCH_BUYBACK_ERROR';

export interface SaveBuyback {
  type: typeof SAVE_BUYBACK;
}

export interface SaveBuybackSuccess {
  type: typeof SAVE_BUYBACK_SUCCESS;
  payload: IBuyback;
}

export interface SaveBuybackError {
  type: typeof SAVE_BUYBACK_ERROR;
}

export interface FetchBuyback {
  type: typeof FETCH_BUYBACK;
}

export interface FetchBuybackSuccess {
  type: typeof FETCH_BUYBACK_SUCCESS;
  payload: IBuyback;
}

export interface FetchBuybackError {
  type: typeof FETCH_BUYBACK_ERROR;
}

export type BuybackActionTypes =
  | SaveBuyback
  | SaveBuybackSuccess
  | SaveBuybackError
  | FetchBuyback
  | FetchBuybackSuccess
  | FetchBuybackError;
